import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

/**
 * Restrict a route to the platform super_admin. Non-super-admins are sent to
 * their own dashboard; logged-out users to login.
 */
export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }
  return auth.isSuperAdmin() ? true : router.createUrlTree(['/dashboard']);
};
